<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div v-if="showRecentVisit">
    <div class="mainbox_one">
      <div class="mainbox_one_title">最近访问过的</div>
      <VueDraggable ref="el" v-model="cardsDatas" @end="updateSortOrder" class="list-box card-row"
        :style="{ '--cols': cardCols }">
          <div class="card-cell" v-for="(cardsData, index) in cardsDatas.slice(0, cardCols)"
            :key="index" :index="cardsData.id" :data-swapy-slot="cardsData.id">
            <div>
              <el-link class="card-link" :href="cardsData.url" :underline="false" target="_blank">
                <el-card class="box_card" shadow="hover" :body-style="{ padding: '0px' }">
                  <el-image class="webimg" :src="cardsData.logoImg"></el-image>
                </el-card>
              </el-link>

              <div class="card_name">
                <el-tooltip class="item" effect="dark" :content="cardsData.content" placement="bottom-start" :disabled="!cardsData.content" popper-class="desc-tooltip">
                  <el-link target="_blank" :underline="false" :href="cardsData.url">
                    <span>{{ cardsData.title }}</span>
                  </el-link>
                </el-tooltip>
              </div>
            </div>
          </div>
        </VueDraggable>
    </div>

    <!-- 修改弹窗 -->
    <el-dialog title="" :visible.sync="dialogFormVisible" width="83.333333%" top="0px" :modal="false">
      <div class="dialog_box">
        <p>修改</p>
        <el-form :model="editCards" ref="editRef" label-width="158px" label-position="left" :rules="rulesCardRef"
          hide-required-asterisk>
          <el-form-item label="网站地址" prop="url">
            <el-input v-model="editCards.url" @focus="showButton = true"></el-input><el-button type="text"
              v-if="showButton" @click="fetchData" :loading="isLoading">解析网址</el-button>
          </el-form-item>
          <el-form-item label="网站名称" prop="title">
            <el-input v-model="editCards.title"></el-input>
          </el-form-item>
          <el-form-item label="网站描述" prop="content">
            <el-input type="textarea" v-model="editCards.content"></el-input>
          </el-form-item>
          <el-form-item label="网站图标" prop="logoImg">
            <el-card class="box_card" shadow="never" :body-style="{ padding: '0px' }">
              <img :src="editCards.logoImg" alt="" class="cover-img" ref="imgRef" />

              <input type="file" style="display: none" accept="image/*" ref="iptFileRef" @change="onEditChange" />
            </el-card>

            <el-button type="text" @click="chooseImgFn">+ 选择图片</el-button>
          </el-form-item>
        </el-form>
        <div class="dialog_box_btn">
          <el-button @click="cancelEdit">取消</el-button>
          <el-button type="primary" @click="saveEditCardData">保存</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getRecommendAPI,
  editRecommendAPI,
  getWebsiteDataAPI,
  saveRecommendLayoutAPI,
} from "@/api";

import { VueDraggable } from "vue-draggable-plus";
import { resolveLogoUrl, getLogoWithCache } from "@/utils/logo";

export default {
  components: {
    VueDraggable,
  },

  data() {
    return {
      //   dialogFormVisible: true,
      isLoading: false,

      editCards: {
        // 修改卡片数据
        id: "",
        url: "",
        title: "",
        content: "",
        logoImgUrl: "",
        logoImg: "",
        logoImgRaw: "", // 后端返回的原始 logo 值（相对路径），保存时使用
      },
      editCardsId: "",
      cardsDatasValue: 0,
      cardsDatas: [],
      layoutList: [],
      // cardsDatas: [
      //   // 卡片数据
      //   {
      //     id: '1',
      //     url: 'https://www.zcool.com.cn/',
      //     logoImg: 'https://favicon.cccyun.cc/https://www.zcool.com.cn/',
      //     title: '站酷',
      //     content: '站酷ZCOOL,中国设计师互动平台'
      //   },
      //   {
      //     id: '2',
      //     url: 'https://www.ui.cn/',
      //     logoImg: 'https://favicon.cccyun.cc/https://www.ui.cn/',
      //     title: 'UI中国',
      //     content: 'UI中国用户体验平台'
      //   },
      //   {
      //     id: '3',
      //     url: 'https://dribbble.com/',
      //     logoImg: 'https://favicon.cccyun.cc/https://dribbble.com/',
      //     title: 'Dribbble',
      //     content: '全球UI设计师作品秀社区'
      //   },
      //   {
      //     id: '4',
      //     url: 'https://www.uisdc.com/',
      //     logoImg: './img/ico-img/youshe.ico',
      //     title: '优设',
      //     content:
      //       '设计师交流学习平台 - 看设计文章，学软件教程，找灵感素材，尽在优设网！'
      //   },
      //   {
      //     id: '5',
      //     url: 'https://www.figma.com/community/',
      //     src: 'https://static.figma.com/app/icon/1/favicon.svg',
      //     title: 'Figma',
      //     content: 'figma官方资源社区'
      //   },
      //   {
      //     id: '6',
      //     url: 'https://www.baidu.com/',
      //     logoImg: 'https://favicon.cccyun.cc/https://www.baidu.com/',
      //     title: '百度',
      //     content: '众里寻她千百度'
      //   }
      // ],

      //   editbuttonStatus: false,
      dialogFormVisible: false, // 弹窗是否显示

      showButton: false, // 解析按钮是否显示

      rulesCardRef: {
        url: [
          { required: true, message: "请输入网址", trigger: "blur" },
          { type: "url", message: "请输入正确的网址", trigger: "blur" },
        ],
        title: [
          { validator: this.validLength, trigger: "blur" },
          // { required: true, message: '请输入网站名称', trigger: 'blur' },
          { min: 1, max: 24, message: "长度1--8个字符", trigger: "blur" },
        ],
        content: [
          // { required: true, message: '请输入网站描述', trigger: 'blur' },
          { validator: this.validateContent, trigger: "blur" },
        ],
        // logoImg: [

        //   { required: true, message: '请上传网站logo', trigger: 'blur' }

        // ]
      },
      cardCols: 6, // 一行卡片列数，按窗口宽度分档算出（1440→6 / 1920→8）
    };
  },

  computed: {
    username() {
      return this.$store.state.username;
    },
    userId() {
      return this.$store.state.userId;
    },
    // 用户中心「显示已访问过的村」开关：关闭后整个区块不渲染
    // 后端字段为 tinyint(0/1)，历史数据或尚未拉取到用户信息时按"显示"处理
    showRecentVisit() {
      const v = this.$store.state.userInfo.show_recent_visit;
      if (v === undefined || v === null || v === "") return true;
      return Number(v) === 1;
    },
  },

  created() {
    // 获取"最近去过的村子"
    this.initCateListFn();
    // 用户点击分类卡片后,实时刷新"最近去过的村子"
    this.$bus.$on("recent-visit", this.initCateListFn);
  },

  mounted() {
    // 列数依赖真实 DOM 宽度，必须在挂载后初始化
    this.setupCardCols();
  },

  beforeDestroy() {
    this.teardownCardCols();
    this.$bus.$off("recent-visit", this.initCateListFn);
  },

  methods: {
    /* ============ 响应式列数 ============
       按窗口宽度分档：1440 屏 6 列、1920 屏 8 列；下限夹在 6（一行最少 6 个、最多 8 个）。
       ▲ 这里的两个分档点必须与 Home.vue 里 .main-content 的 --cols 媒体查询一致 ——
         容器宽度跟着列数走（6 列 968 / 7 列 1144 / 8 列 1320），才能让列间距恒为 88px。 */
    setupCardCols() {
      this.cardCols = this.getCardCols();
      window.addEventListener("resize", this.handleResize);
    },

    teardownCardCols() {
      window.removeEventListener("resize", this.handleResize);
    },

    // 08-13 定稿方案的分档（1440 屏 6 列 / 1920 屏 8 列），下限夹到 6
    getCardCols() {
      const t = window.innerWidth;
      return t >= 1800 ? 8 : t >= 1600 ? 7 : 6;
    },

    handleResize() {
      this.cardCols = this.getCardCols();
    },

    // 校验字符长度的方法
    validLength(rule, value, callback) {
      function getStrLength(str) {
        return str.replace(/[^\x00-\xff]/g, "xxx").length;
      }
      if (!value) {
        callback(new Error("输入不能为空"));
      } else if (getStrLength(value) < 1) {
        callback(new Error("不能少于 1 个字符"));
      } else if (getStrLength(value) > 24) {
        callback(new Error("不能超过 24 个字符"));
      } else {
        callback();
      }
    },

    // 校验网站简介长度:最多 100 个汉字(英文 3 字符折算 1 个汉字,即 300 字符)
    validateContent(rule, value, callback) {
      if (!value) {
        callback();
        return;
      }
      const len = value.replace(/[^\x00-\xff]/g, "xxx").length;
      if (len > 300) {
        callback(new Error("简介最多 100 个汉字(英文 300 个字符)"));
      } else {
        callback();
      }
    },

    // 获取村花3.0
    async initCateListFn() {
      try {
        const res = await getRecommendAPI(this.userId);

        if (res.data && res.data.data) {
          this.cardsDatas = res.data.data.map((card) => {
            // 优先使用 localStorage 中的 dataURL 缓存（相对路径 logo），避免每次刷新重新请求图片
            const logoImg = getLogoWithCache(card.logoImg, this.$backurl);
            return {
              ...card,
              logoImg,
            };
          });

          // console.log("Cards data:", this.cardsDatas); // 打印数据以调试
        } else {
          console.error("Error: Unexpected API response", res);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    // 输入网址获取该网站标题简介和logo数据
    async fetchData() {
      try {
        this.isLoading = true;
        const url = this.editCards.url;
        const res = await getWebsiteDataAPI(url);

        // 只更新特定的字段
        this.editCards.title = res.data.title;
        this.editCards.content = res.data.content;
        // 原始值（可能是相对路径 uploads/...）单独保存，用于写入数据库；
        // logoImg 拼接后端地址后仅用于弹窗预览显示
        const rawLogoImg = res.data.logoImg || '';
        this.editCards.logoImgRaw = rawLogoImg;
        this.editCards.logoImg = resolveLogoUrl(rawLogoImg, this.$backurl);
        console.log(this.editCards);
      } catch (error) {
        console.error(error);
        // 如果发生错误，你可以在这里处理，例如显示一个错误消息
        this.$message.error("获取网站数据失败 请自己添加");
      } finally {
        this.isLoading = false;
      }
    },

    // 显示修改的数据
    editCardsData(cardsData, index) {
      this.editCards.id = cardsData.id;
      this.editCards.url = cardsData.url;
      this.editCards.title = cardsData.title;
      this.editCards.content = cardsData.content;
      this.editCards.logoImg = cardsData.logoImg;
      this.editCards.logoImgRaw = ""; // 清空上次解析的原始值，避免误存到其他卡片
      this.dialogFormVisible = true;
      this.editCardsId = index;
      // console.log(this.editCards)
    },

    chooseImgFn() {
      this.$refs.iptFileRef.click();
    },

    // 封面选择改变的事件
    // 监听文件选择框的 change 事件
    onEditChange(e) {
      // 获取到用户选择的封面
      const files = e.target.files;
      // console.log(files)
      // 检查文件大小，如果超过100kb，则显示警告并返回
      if (files[0] && files[0].size === 0) {
        this.$message.error("图片内容为空，请重新选择");
        return;
      }
      if (files[0].size > 102400) {
        // alert('logo太大了,不能超过100kb! 你可以加入站村的微信群向站友寻求帮助')
        this.$message.error("图片大小超过100kb!");
        return;
      }
      // 用户选择了封面
      this.editCards.logoImgUrl = files[0];
      const url = URL.createObjectURL(files[0]);
      this.$refs.imgRef.setAttribute("src", url);

      this.$refs.editRef.validateField("logoImg");
    },

    // 保存修改的数据

    saveEditCardData() {
      this.$refs.editRef.validate(async (valid) => {
        if (!valid) return;
        const formData = new FormData();
        formData.append("id", this.editCards.id);
        formData.append("title", this.editCards.title);
        formData.append("content", this.editCards.content);
        formData.append("url", this.editCards.url);

        // 判断logoImgUrl是文件还是链接
        if (this.editCards.logoImgUrl instanceof File) {
          // 如果是文件，添加到表单
          formData.append("logoImg", this.editCards.logoImgUrl);
        } else if (typeof this.editCards.logoImg === "string") {
          // 优先保存原始值（相对路径），避免把带本机地址的完整 URL 写进数据库；
          // 空 data URL（data:,）说明没有有效 logo，不提交
          const logoValue = this.editCards.logoImgRaw || this.editCards.logoImg;
          if (logoValue && logoValue !== 'data:,') {
            formData.append("logoImg", logoValue);
          }
        }
        try {
          const { data: res } = await editRecommendAPI(formData);
          if (res.status !== 0) {
            this.$message.error(res.message || '保存失败');
            return;
          }
          // 重新请求列表数据，成功后关闭弹窗
          await this.initCateListFn();
          this.showButton = false;
          this.dialogFormVisible = false;
        } catch (error) {
          console.error('保存失败:', error);
          this.$message.error('保存失败，请重试');
        }
      });
    },

    cancelEdit() {
      this.showButton = false;
      this.dialogFormVisible = false;
      this.editCards = {};
    },

    //拖拽卡片

    async updateSortOrder() {
      const updates = this.cardsDatas.map((item, index) => ({
        id: item.id,
        sort_order: index + 1,
      }));

      // console.log(updates); // 打印更新数据以确认格式

      const userId = this.userId; // 假设 this.userId 存储当前用户的 ID

      try {
        await saveRecommendLayoutAPI(userId, updates); // 调用 API
        // this.$message.success('排序更新成功！'); // 提示用户
      } catch (error) {
        this.$message.error("更新排序失败！"); // 错误处理
        console.error("更新失败:", error); // 打印错误以便调试
      }
    },

  },
};
</script>

<style scoped>
.mainbox_one {
  height: auto;
  padding-top: 32px;
  max-width: 100%; /* 宽度跟随上层 .main-content（唯一基准 968px），不再自己限宽 */
  margin: 0 auto;    /* 居中 → 标题、卡片、banner 三者左右缘对齐 */
}

.mainbox_one_title {
  width: 400px;
  height: 33px;
  padding-block-end: 18px;
  font-size: 24px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1d1d1f;
  line-height: 33px;
}

/* .grid-content {
  margin-top: 0px;
  height: 120px;

  padding-block-end: 24px;
}

.bg-purple-dark {
  background: #ffffff;
} */

/* 卡片行：固定 88px 列 + space-between 把余量摊成列间距。
   间距恒 88px 是由 .main-content 的宽度保证的（Home.vue：宽度 = 列数×88 + (列数−1)×88，
   6 列 968 / 7 列 1144 / 8 列 1320）—— 容器宽正好时余量 ÷ (列数−1) 恰好 = 88。
   所以这里既不要写 column-gap，也不要动 minmax 的 88px 上限，否则间距会失准。
   首列贴容器左缘、末列贴容器右缘 ↔ 与 banner 天然对齐。
   minmax(0, 88px)：常规宽度下每列就是 88px；窗口窄到放不下 cols×88 时才让列收窄
   （列数下限 6，见 getCardCols），这样固定 88px 也不会在窄屏横向溢出。 */
.card-row {
  display: grid;
  grid-template-columns: repeat(var(--cols), minmax(0, 88px));
  justify-content: space-between;
  row-gap: 24px;
}

.card-cell > div {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 卡片外层链接块级,避免行内 <a> 影响布局 */
.card-cell .card-link {
  display: block;
  width: 100%;
}

/* 卡片 88×88：外框 = 栅格列宽，而列宽上限就是 88px，
   所以常规窗口（内容区 ≥ 6×88）下渲染出来正好 88×88；
   box-sizing:border-box = 内描边：边框画在 88 内部，外框正好 88，与 grid 列宽一致
   （Element 的 .el-card 默认 content-box，不写这句外框会变成 90、首尾错位 2px） */
.card-cell .box_card {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 12px;
  border: 1px solid #eeeeee;
  background-color: rgb(255, 255, 255);
}

/* 卡片内部水平垂直居中 */
.card-cell .box_card ::v-deep .el-card__body {
  height: 100%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card_header {
  position: absolute;
  top: 4px;
  right: 4px;
  opacity: 0;
  z-index: 2;
}

.el-card:hover .card_header {
  opacity: 1;
}

.el-icon-edit {
  color: #666;
}

.webimg {
  width: 32px;
  height: 32px;
  display: block;
}

.card-cell .card_name {
  text-align: center;
  width: 100%;
  height: 20px;
  font-size: 14px;
  /* font-family: PingFangSC-Regular, PingFang SC; */
  font-weight: 400;
  color: #333333;
  line-height: 20px;
  margin-top: 8px;
  margin-right: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cover-img {
  width: 32px;
  height: 32px;
  display: block;
  margin: 0 auto;
  /* object-fit: cover; */
}

/* 弹窗(修改)里的网站图标框:88×88 正方形(内描边),图标居中 */
.dialog_box .box_card {
  box-sizing: border-box;
  width: 88px;
  height: 88px;
  border-radius: 12px;
  border: 1px solid #eeeeee;
  background-color: rgb(255, 255, 255);
}

.dialog_box .box_card ::v-deep .el-card__body {
  height: 100%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
